module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp1_8004.6c1411a7.png";